// extracted by mini-css-extract-plugin
export default {"formError":"style_formError__PSrcN"};